import { APP_VERSION } from './version';

export const environment = {
  production: true,
  urlApi: 'https://centerapiteste.scond.com.br/',
  urlOriginSigmaClient: 'https://frontend.sigma-x-staging.segware.com',
  urlShield: 'https://shield-staging.segware.io/auth/center/',
  urlShieldApi: 'https://shield-api.sigma-x-staging.segware.com/auth/center/',
  posthogEnabled: true,
  posthogSessionReplayEnabled: true,
  posthogApiKey: 'phc_p2Nj9ApzmFyyhSR3Uvt27G7nzEJntDSdJueSEMJYQZn7',
  posthogHost: 'https://posthog.segware.com',
  ambiente: 'homolog',
  version: APP_VERSION,
  facebookAppId: '1648837096573983',
  facebookConfigId: '1070149949135771',
  facebookGraphVersion: 'v25.0',
  urlCenterWeb: 'https://centerteste.scond.com.br/',
  // Chaveamento da migração do pós-login para React: quando true, o login bem-sucedido
  // cai na rota '/' (PostLoginRedirect), que resolve a home do usuário replicando a
  // árvore de decisão do goHome legado. Quando false, o goHome legado permanece no controle.
  redirectLoginToReactPostLogin: true,
  // Default do chaveamento página React ↔ folha Angular quando não há flag a consultar
  // (SDK desligado, carregando ou sem valor para a chave). Chave ausente = folha Angular.
  migrationFlags: {} as Record<string, boolean>,
  // Default do kill switch global (react-ui-kill-switch) no mesmo caso. true força a folha
  // em todo módulo.
  migrationKillSwitch: false
};
